<template>
  <div>
    <div class="container pt-4 pt-sm-3 pb-3">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
          <h1 class="h5">
            <router-link v-if="newTireReport" :to="{ name: 'trailer', params: { id: newTireReport.tireReportId } }">
              <i class="far fa-lg fa-angle-left mr-2"></i>Remarks
            </router-link>
          </h1>
          <hr />
          <div class="form-group mb-1">
            <p class="small grey">Only for information not covered by tire change details.</p>
            <textarea v-model="remark" class="form-control" rows="5" placeholder="Write something..."></textarea>
          </div>
          <button
            @click="save"
            tag="button"
            :disabled="!canSave"
            class="btn btn-info btn-lg btn-block mt-4"
          >Save remark</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  metaInfo: {
    title: "Remarks"
  },
  data: () => {
    return {
      remark: null
    };
  },
  computed: {
    ...mapState("tireReports", ["newTireReport"]),
    canSave: function() {
      return !!this.remark;
    }
  },
  watch: {
    "newTireReport.remark": function (remark) {
      this.remark = remark
    },
    lastName: function (val) {
      this.fullName = this.firstName + ' ' + val
    }
  },
  methods: {
    ...mapActions("tireReports", ["addRemark", "continueIncompleteReport"]),
    save() {
      this.addRemark(this.remark);
      this.$router.push({
        name: "trailer",
        params: { id: this.newTireReport.tireReportId }
      });
    }
  },
    mounted() {
    if (!this.newTireReport || !this.newTireReport.tireReportId) {
      if (this.$route.params.id) {
        this.continueIncompleteReport(this.$route.params.id);
      } else {
        this.$router.replace({ name: "frontpage" });
      }
      return;
    }

    if (this.newTireReport.remark) {
      this.remark = this.newTireReport.remark;
    }
  }
};
</script>